require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-if-nothing-goes-wrong-youre-not-innovating-housing-technology.json") })
        }
      }, "path---blog-if-nothing-goes-wrong-youre-not-innovating-housing-technology");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-if-nothing-goes-wrong-youre-not-innovating-housing-technology!./.cache/json/blog-if-nothing-goes-wrong-youre-not-innovating-housing-technology.json
// module id = 828
// module chunks = 231608221292675